// Saudi Arabia Cities and Towns Data
// Major cities first, then alphabetical order

export const saudiCities = [
  // Major Cities (Favorites)
  { value: 'riyadh', label: { en: 'Riyadh', ar: 'الرياض' } },
  { value: 'jeddah', label: { en: 'Jeddah', ar: 'جدة' } },
  { value: 'mecca', label: { en: 'Mecca', ar: 'مكة المكرمة' } },
  { value: 'medina', label: { en: 'Medina', ar: 'المدينة المنورة' } },
  { value: 'dammam', label: { en: 'Dammam', ar: 'الدمام' } },
  { value: 'khobar', label: { en: 'Al Khobar', ar: 'الخبر' } },
  { value: 'taif', label: { en: 'Taif', ar: 'الطائف' } },
  { value: 'buraidah', label: { en: 'Buraidah', ar: 'بريدة' } },
  { value: 'alqassim', label: { en: 'Al Qassim', ar: 'القصيم' } },
  { value: 'tabuk', label: { en: 'Tabuk', ar: 'تبوك' } },
  { value: 'hail', label: { en: 'Hail', ar: 'حائل' } },
  { value: 'khamis_mushait', label: { en: 'Khamis Mushait', ar: 'خميس مشيط' } },
  { value: 'abha', label: { en: 'Abha', ar: 'أبها' } },
  { value: 'najran', label: { en: 'Najran', ar: 'نجران' } },
  { value: 'jazan', label: { en: 'Jazan', ar: 'جازان' } },
  { value: 'yanbu', label: { en: 'Yanbu', ar: 'ينبع' } },
  
  // Cities and Towns (Alphabetical)
  { value: 'abu_arish', label: { en: 'Abu Arish', ar: 'أبو عريش' } },
  { value: 'ad_dilam', label: { en: 'Ad Dilam', ar: 'الدلم' } },
  { value: 'afif', label: { en: 'Afif', ar: 'عفيف' } },
  { value: 'al_aflaj', label: { en: 'Al Aflaj', ar: 'الأفلاج' } },
  { value: 'al_ahsa', label: { en: 'Al Ahsa', ar: 'الأحساء' } },
  { value: 'al_artawiyah', label: { en: 'Al Artawiyah', ar: 'الارطاوية' } },
  { value: 'al_baha', label: { en: 'Al Baha', ar: 'الباحة' } },
  { value: 'al_bukayriyah', label: { en: 'Al Bukayriyah', ar: 'البكيرية' } },
  { value: 'al_dawadimi', label: { en: 'Al Dawadimi', ar: 'الدوادمي' } },
  { value: 'al_diriyah', label: { en: 'Al Diriyah', ar: 'الدرعية' } },
  { value: 'al_ghat', label: { en: 'Al Ghat', ar: 'الغاط' } },
  { value: 'al_hareeq', label: { en: 'Al Hareeq', ar: 'الحريق' } },
  { value: 'al_hawiyah', label: { en: 'Al Hawiyah', ar: 'الحوية' } },
  { value: 'al_jubail', label: { en: 'Al Jubail', ar: 'الجبيل' } },
  { value: 'al_kharj', label: { en: 'Al Kharj', ar: 'الخرج' } },
  { value: 'al_lith', label: { en: 'Al Lith', ar: 'الليث' } },
  { value: 'al_majmaah', label: { en: 'Al Majmaah', ar: 'المجمعة' } },
  { value: 'al_mithnab', label: { en: 'Al Mithnab', ar: 'المذنب' } },
  { value: 'al_mubarraz', label: { en: 'Al Mubarraz', ar: 'المبرز' } },
  { value: 'al_muzahimiyah', label: { en: 'Al Muzahimiyah', ar: 'المزاحمية' } },
  { value: 'al_namas', label: { en: 'Al Namas', ar: 'النماص' } },
  { value: 'al_qatif', label: { en: 'Al Qatif', ar: 'القطيف' } },
  { value: 'al_qunfudhah', label: { en: 'Al Qunfudhah', ar: 'القنفذة' } },
  { value: 'al_rass', label: { en: 'Al Rass', ar: 'الرس' } },
  { value: 'al_saih', label: { en: 'Al Saih', ar: 'السيح' } },
  { value: 'al_sulayyil', label: { en: 'Al Sulayyil', ar: 'السليل' } },
  { value: 'al_ula', label: { en: 'Al Ula', ar: 'العلا' } },
  { value: 'al_uyaynah', label: { en: 'Al Uyaynah', ar: 'العيينة' } },
  { value: 'al_wajh', label: { en: 'Al Wajh', ar: 'الوجه' } },
  { value: 'al_zulfi', label: { en: 'Al Zulfi', ar: 'الزلفي' } },
  { value: 'arar', label: { en: 'Arar', ar: 'عرعر' } },
  { value: 'as_sulayyil', label: { en: 'As Sulayyil', ar: 'السليل' } },
  { value: 'ash_shimasiyah', label: { en: 'Ash Shimasiyah', ar: 'الشماسية' } },
  { value: 'at_taif', label: { en: 'At Taif', ar: 'الطائف' } },
  { value: 'badr', label: { en: 'Badr', ar: 'بدر' } },
  { value: 'baha', label: { en: 'Baha', ar: 'الباحة' } },
  { value: 'baljurashi', label: { en: 'Baljurashi', ar: 'بلجرشي' } },
  { value: 'bareq', label: { en: 'Bareq', ar: 'بارق' } },
  { value: 'bisha', label: { en: 'Bisha', ar: 'بيشة' } },
  { value: 'dhahran', label: { en: 'Dhahran', ar: 'الظهران' } },
  { value: 'duba', label: { en: 'Duba', ar: 'ضباء' } },
  { value: 'dumat_al_jandal', label: { en: 'Dumat Al Jandal', ar: 'دومة الجندل' } },
  { value: 'farasān', label: { en: 'Farasān', ar: 'فرسان' } },
  { value: 'hafar_al_batin', label: { en: 'Hafar Al Batin', ar: 'حفر الباطن' } },
  { value: 'hofuf', label: { en: 'Hofuf', ar: 'الهفوف' } },
  { value: 'hawtat_sudair', label: { en: 'Hawtat Sudair', ar: 'حوطة سدير' } },
  { value: 'hotat_bani_tamim', label: { en: 'Hotat Bani Tamim', ar: 'حوطة بني تميم' } },
  { value: 'huraimila', label: { en: 'Huraimila', ar: 'حريملاء' } },
  { value: 'khafji', label: { en: 'Khafji', ar: 'الخفجي' } },
  { value: 'khamis_mushayt', label: { en: 'Khamis Mushayt', ar: 'خميس مشيط' } },
  { value: 'khaybar', label: { en: 'Khaybar', ar: 'خيبر' } },
  { value: 'layla', label: { en: 'Layla', ar: 'ليلى' } },
  { value: 'mahd_al_dhahab', label: { en: 'Mahd Al Dhahab', ar: 'مهد الذهب' } },
  { value: 'marat', label: { en: 'Marat', ar: 'مرات' } },
  { value: 'muhayil', label: { en: 'Muhayil', ar: 'محايل' } },
  { value: 'qaisumah', label: { en: 'Qaisumah', ar: 'قيصومة' } },
  { value: 'qurayyat', label: { en: 'Qurayyat', ar: 'القريات' } },
  { value: 'rabigh', label: { en: 'Rabigh', ar: 'رابغ' } },
  { value: 'rafha', label: { en: 'Rafha', ar: 'رفحاء' } },
  { value: 'ras_tanura', label: { en: 'Ras Tanura', ar: 'رأس تنورة' } },
  { value: 'riyad_al_khabra', label: { en: 'Riyad Al Khabra', ar: 'رياض الخبراء' } },
  { value: 'sabya', label: { en: 'Sabya', ar: 'صبيا' } },
  { value: 'safwa', label: { en: 'Safwa', ar: 'صفوى' } },
  { value: 'saihat', label: { en: 'Saihat', ar: 'سيهات' } },
  { value: 'sakaka', label: { en: 'Sakaka', ar: 'سكاكا' } },
  { value: 'sharurah', label: { en: 'Sharurah', ar: 'شرورة' } },
  { value: 'shaqra', label: { en: 'Shaqra', ar: 'شقراء' } },
  { value: 'tabarjal', label: { en: 'Tabarjal', ar: 'طبرجل' } },
  { value: 'thadiq', label: { en: 'Thadiq', ar: 'ثادق' } },
  { value: 'thuwal', label: { en: 'Thuwal', ar: 'ثول' } },
  { value: 'turaif', label: { en: 'Turaif', ar: 'طريف' } },
  { value: 'umluj', label: { en: 'Umluj', ar: 'أملج' } },
  { value: 'unizah', label: { en: 'Unizah', ar: 'عنيزة' } },
  { value: 'wadi_al_dawasir', label: { en: 'Wadi Al Dawasir', ar: 'وادي الدواسر' } },
  { value: 'uyun_al_jiwa', label: { en: 'Uyun Al Jiwa', ar: 'عيون الجواء' } },
  { value: 'other', label: { en: 'Other', ar: 'أخرى' } }
];

// Group cities by category for easier rendering
export const citiesGrouped = {
  major: saudiCities.slice(0, 16), // First 16 are major cities
  others: saudiCities.slice(16)    // Rest are alphabetical
};